import styled, { css } from 'styled-components';
import { Link } from 'react-router-dom';
import { FONT_SANS } from '../constants';
import { colors } from '../theme/colors';

const base = css`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  font-family: ${FONT_SANS};
  font-weight: 700;
  font-size: 15px;
  line-height: 1;
  border-radius: 999px;
  padding: 14px 24px;
  text-decoration: none;
  cursor: pointer;
  border: 1px solid transparent;
  transition: transform 0.15s ease, box-shadow 0.15s ease, background 0.15s ease;

  &:hover {
    text-decoration: none;
    transform: translateY(-1px);
  }

  &:active {
    transform: translateY(0);
  }
`;

export const ButtonPrimary = styled.button`
  ${base};
  background: ${colors.primary};
  color: ${colors.primaryText};
  box-shadow: 0 4px 14px rgba(44, 42, 41, 0.22);

  &:hover {
    background: ${colors.primaryHover};
  }
`;

export const LinkPrimary = styled(Link)`
  ${base};
  background: ${colors.primary};
  color: ${colors.primaryText};
  box-shadow: 0 4px 14px rgba(44, 42, 41, 0.22);

  &:hover {
    background: ${colors.primaryHover};
    color: ${colors.primaryText};
  }
`;

export const LinkSecondary = styled(Link)`
  ${base};
  background: ${colors.secondary};
  color: ${colors.secondaryText};
  border-color: ${colors.secondaryBorder};

  &:hover {
    background: #fff;
    color: ${colors.secondaryText};
  }
`;

export const AnchorSecondary = styled.a`
  ${base};
  background: ${colors.secondary};
  color: ${colors.secondaryText};
  border-color: ${colors.secondaryBorder};

  &:hover {
    background: #fff;
    color: ${colors.secondaryText};
  }
`;

export const LinkAccent = styled(Link)`
  ${base};
  background: ${colors.accentSoft};
  color: ${colors.accent};
  border-color: rgba(15, 118, 110, 0.2);
  padding: 10px 18px;
  font-size: 14px;
  box-shadow: none;

  &:hover {
    background: #d1faf0;
    color: ${colors.accent};
  }
`;
